// -----------------------------------------------------------
// On scroll pin some elements on screen
// Janovec - 18.10.22
// V 1.1 - alfa

import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import Scroller from "../../Scroller/Scroller";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin)

const ScrollPin = {

    init(el) {
        this.el = el;
        this.items = el.find('[container]');
        // console.log(this.el)
        this.top = this.el.offset().top;
        // console.log('ScrollPin this.top >', this.top)
        this.bind();
    },

    bind() {
        gsap.set(this.el, {height: ''});

        this.items.each((i, item) => {
            this.bindScroll(i, item);
            this.bindAnimation(i, item);
        });

        this.lastScrollTop = 0;

        // $(window).scroll((evt) => {
        //     const window = evt.currentTarget;
        //
        //     if (this.lastScrollTop > window.scrollY) {
        //         console.log("scrolling up");
        //     } else if (this.lastScrollTop < window.scrollY) {
        //         console.log("scrolling down");
        //     }
        //     this.lastScrollTop = window.scrollY;
        // });
    },

    bindScroll(i, item) {
        ScrollTrigger.create({
            id: 'pinTrigger' + i,
            trigger: item,
            pin: true,
            start: () => this.top + (window.innerHeight * i),
            endTrigger: this.el,
            end: 'bottom bottom',
            pinSpacing: false,
            // onEnter: (evt) => this.scrollTo(evt),
            // onEnterBack: (evt) => this.onEnterBack($(evt.trigger)),
            invalidateOnRefresh: true,
            // markers: true,
        });
    },

    onEnter(evt) {
        const el = $(evt.trigger);
        const order = el.closest('[container]').attr('order');
        let top = parseInt(order) * window.innerHeight;
        top = this.top + top;
        // console.log('onEnter() ', el, order, top);

        this.scrollTo(top);
    },

    scrollTo(evt) {
        console.log('scrollTo() ', $(evt.trigger))
        const top = $(evt.trigger).offset().top + window.innerHeight
        gsap.to(window, {
            duration: Scroller.animTime,
            scrollTo: {y: top, offsetY: 0}
        });
    },

    bindAnimation(i, item) {
        item.tl = gsap.timeline({
            scrollTrigger: {
                scrub: true,
                start: () => this.top + (window.innerHeight * i),
                end: () => this.top + (window.innerHeight * (i + 1)),
                invalidateOnRefresh: true,
            }
        });

        if (window.innerHeight < 540) {
            item.tl.to($(item).find('[block="text"] p'), {y: -window.innerHeight / 2, opacity: 0}, 0.4);
            item.tl.to($(item).find('[block="text"] h2'), {y: -window.innerHeight / 2, opacity: 0}, 0.4);
        } else {
            item.tl.to($(item).find('[block="text"] p'), {opacity: 0}, 0.4);
            item.tl.to($(item).find('[block="text"] button'), {opacity: 0}, 0.4);
        }

        let next = this.items.filter('[order="' + (i + 2) + '"]');
        if (!next.length) return;
        item.tl.to(next.find('[block="image"]'), {backgroundPositionY: '0%', ease:'power2.in'}, 0.4);
    },

    kill() {
        if (!this.items) return

        this.items.each((i, item) => {
            item.tl.pause(0).kill(true);
            gsap.set($(item), {clearProps: true});
            gsap.set($(item).find('p'), {clearProps: true});
            gsap.set($(item).find('h2'), {clearProps: true});
            ScrollTrigger.getById('pinTrigger' + i).kill(true);
        });
    },
};

export default ScrollPin;
// window.ScrollPin = ScrollPin;